export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./betconstruct-frame.vue?vue&type=template&id=64fd2bb0"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/betconstruct/betconstruct-frame.vue?vue&type=template&id=64fd2bb0
// module id = ZKFH
// module chunks = 0